import PrivateAPIResource from "../../services/PrivateAPIResource";
import * as types from '../actionTypes';

function createPortalContactSuccess(portalContact) {
    return {type: types.CREATE_PORTAL_CONTACT_PERSON_SUCCESS, portalContact};
}

function loadPortalContactSuccess(portalContacts) {
    return {type: types.LOAD_PORTAL_CONTACTS_SUCCESS, portalContacts};
}

function getPortalContactSuccess(portalContact) {
    return {type: types.GET_PORTAL_CONTACT_SUCCESS, portalContact};
}

function updatePortalContactSuccess(portalContact) {
    return {type: types.UPDATE_PORTAL_CONTACT_SUCCESS, portalContact};
}

function deletePortalContactSuccess(id) {
    return {type: types.DELETE_PORTAL_CONTACT_SUCCESS, id};
}

function loadCompanyPortalContactsSuccess(companyPortalContacts) {
    return {type: types.LOAD_COMPANY_PORTAL_CONTACT_PERSONS_SUCCESS, companyPortalContacts}
}

export function resetPortalContact() {
    return { type: types.RESET_PORTAL_CONTACT };
}

export function createPortalContact(data) {
    return function (dispatch) {
        return PrivateAPIResource.create('portal-contacts', data, true)
            .then((data) => {
                dispatch(createPortalContactSuccess(data));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function loadPortalContacts(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource.all(`portal-contacts?page=${page}`, sortParams)
            .then((portalContacts) => {
                dispatch(loadPortalContactSuccess(portalContacts));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function loadCompanyPortalContacts(id) {
    return function (dispatch) {
        return PrivateAPIResource.all(`company-portal-contacts/${id}`)
            .then((portalContacts) => {
                dispatch(loadCompanyPortalContactsSuccess(portalContacts));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function getPortalContact(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('portal-contacts', id)
            .then((portalContact) => {
                dispatch(getPortalContactSuccess(portalContact));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function updatePortalContact(id, data) {
    return function (dispatch) {
        return PrivateAPIResource.update('portal-contacts', id, data, true)
            .then((portalContact) => {
                dispatch(updatePortalContactSuccess(portalContact));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function deletePortalContact(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('portal-contacts', id)
            .then(() => {
                dispatch(deletePortalContactSuccess(id));
            })
            .catch(err => {
                throw  err;
            });
    }
}




// WEBPACK FOOTER //
// ./web/src/actions/portal-contact/portalContactActions.js